import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { directoryListLoader } from "@/hooks/useScrapedPage";

const ElhandelLista = lazy(() => import("@/pages/content/ElhandelLista"));

export const Route = createFileRoute("/elhandel/")({
  // Hela A–Ö-listan hämtas på servern så att alla bolagssidor länkas med
  // vanliga <a href> i serverns HTML (tidigare fylldes listan i webbläsaren).
  loader: ({ context }) => directoryListLoader(context.queryClient, "elhandel"),
  head: () => seoHead("/elhandel", { description: "Utforska Sveriges elhandelsbolag – jämför avtal, priser och villkor hos varje leverantör." }),
  component: ElhandelListaRoute,
});

function ElhandelListaRoute() {
  const { items } = Route.useLoaderData();
  return <ElhandelLista initialItems={items} />;
}
